import { RootState } from '..';
import { ICreateNewsError, IData } from './types';

export const allNewsSelector = (state: RootState): IData =>
  state.news.list.data;

export const errorsSelector = (
  state: RootState,
): ICreateNewsError | undefined => state.news.errors;
